import React from 'react';
import T from 'i18n-react';

import MetaTags from 'Components/MetaTags/MetaTags';
import { MotorwayPayModulrPage } from 'Components/StaticPages/MotorwayPayModulr/MotorwayPayModulrPage';
import texts from 'Components/texts.json';

T.setTexts(texts);

const MotorwayPayModulr = (): React.ReactElement => (
	<>
		<MetaTags
			// @ts-ignore needs to rewrite MetaTags to TS, and stop using withRouter for it to work
			noIndex
			description={T.translate('metaTags.pages.motorwayPayModulr.description')}
			title={T.translate('metaTags.pages.motorwayPayModulr.title')}
		/>
		<MotorwayPayModulrPage />
	</>
);

export default MotorwayPayModulr;
